import moment from 'moment';
import { MoneyFormat } from '@/backoffice/components/filters/NumberFilter';

export const formatUnixDateFilter = function (value: any, format = 'DD.MM.YYYY HH:mm:ss') {
  return moment.unix(value).format(format);
};

export const FiltersMixin = {
  filters: {
    formatUnixtime: formatUnixDateFilter,
    formatMoney: MoneyFormat,
  },
};
